module.exports = __webpack_public_path__ + "3fccd14759a72821347d907cf4a8d48c.svg";